import { RightNavigationTop } from "@components/Layouts/CatalogLayout/RightNavigation/RightNavigaitonTop";
import RightNavigation from "@components/Layouts/CatalogLayout/RightNavigation/RightNavigation";
import { RightNavigationBottom } from "@components/Layouts/CatalogLayout/RightNavigation/RightNavigationBottom";
import RightNavigationLayout from "@components/Layouts/CatalogLayout/RightNavigation/RightNavigationLayout";
import { EXPANDED_RIGHT_NAVIGATION_CONTENT_CLASS_NAME } from "./constants";

const RightNavigationComponent = () => {
	return (
		<>
			<RightNavigationTop />
			{/* The underlay turns pointer events on for its direct children: a box here would cover the article scrollbar. */}
			<div className={EXPANDED_RIGHT_NAVIGATION_CONTENT_CLASS_NAME}>
				<RightNavigationLayout>
					<div className="flex min-h-0 flex-1 flex-col">
						<RightNavigation />
					</div>
				</RightNavigationLayout>
			</div>
			<RightNavigationBottom />
		</>
	);
};

export default RightNavigationComponent;
